import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Route, Link, NavLink } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import cn from 'classnames'
import { debounce, get, isEmpty } from 'lodash'
import { Typography } from '@material-ui/core'

import Icon from '@scoir/components-core/dist/components/Icon'
import Avatar from '@scoir/components-core/dist/components/Avatar'
import OpaqueDropdownToggle from '@scoir/components-core/dist/components/OpaqueDropdownToggle'
import OpaqueDropdownMenuItem from '@scoir/components-core/dist/components/OpaqueDropdownMenuItem'

import DirectMessaging from '../DirectMessaging'
import Inbox from '../Inbox'
import NotificationsIndicator from '../Inbox/NotificationsIndicator'
import SearchBox from '../SearchBox'

import scoirLogo from '../scoir-logo.png'
import downArrowIcon from 'icons/keyboard-arrow-down.svg'
import menuIcon from 'icons/menu.svg'

import './index.scss'

const defaultAvatar = Avatar.DEFAULT_AVATAR
const TieredNavigationMessaging = (props) => (
  <DirectMessaging
    {...props}
    theme="light"
  />
)
const TieredNavigationInbox = (props) => (
  <Inbox
    {...props}
    theme="light"
  />
)
const TieredNavagationNotificationsIndicator = (props) => (
  <NotificationsIndicator
    {...props}
    theme="light"
  />
)
class TieredNavigation extends React.Component {
  state = {
    headerHeight: 0,
  }
  componentDidMount() {
    this.setHeaderHeight()
    window.addEventListener('resize', this.setDebouncedHeaderHeight)
  }
  componentDidUpdate() {
    const headerHeight = get(this, 'fixedNavRef.offsetHeight', 0)
    if (this.state.headerHeight !== headerHeight) {
      this.setHeaderHeight()
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.setDebouncedHeaderHeight)
  }
  setDebouncedHeaderHeight = debounce(() => this.setHeaderHeight(), 75, true, true)

  setHeaderHeight() {
    const headerHeight = get(this, 'fixedNavRef.offsetHeight', 0)
    this.setState({ headerHeight })
  }

  getAvatarUrl(userAvatarUrl) {
    if (userAvatarUrl === '') {
      return defaultAvatar
    }
    return userAvatarUrl || defaultAvatar
  }
  renderMenuLink(item) {
    if (!isEmpty(item.externalPath)) {
      if (item.path) {
        return (
          <Route
            path={item.path}
            children={({ match }) => (
              <a
                href={item.externalPath}
                className={cn('custom-link', { active: match })}
              >
                {item.label}
              </a>
            )}
          />
        )
      }
      return (
        <a
          href={item.externalPath}
          className="custom-link"
        >
          {item.label}
        </a>
      )
    }
    return (
      <NavLink
        to={{
          pathname: item.path,
          search: item.search,
        }}
      >
        {item.label}
      </NavLink>
    )
  }
  renderSash(item) {
    return item.sashText && <div className={cn('sash', item.sashClassName)}>{item.sashText}</div>
  }
  renderMenuItems() {
    return (
      <div className="menu-item-container">
        <div className="menu-items full-view">
          {this.props.menuItems.map((item) => {
            return (
              <div
                key={item.label}
                className="menu-item-elem"
              >
                {this.renderMenuLink(item)}
                {this.renderSash(item)}
              </div>
            )
          })}
        </div>
        <Dropdown
          id="header-navigation-responsive-dropdown"
          className="responsive-navigation"
        >
          <OpaqueDropdownToggle
            bsRole="toggle"
            className="menu-toggle"
          >
            <Icon
              def={menuIcon}
              size="sm"
            />
            Menu
          </OpaqueDropdownToggle>
          <Dropdown.Menu className="menu-items">
            {this.props.menuItems.map((item) => {
              return (
                <OpaqueDropdownMenuItem
                  key={item.label}
                  className="menu-item-elem"
                >
                  {this.renderMenuLink(item)}
                  {this.renderSash(item)}
                  <div className="stacked-sub-nav">{this.renderSubMenuForItem(item)}</div>
                </OpaqueDropdownMenuItem>
              )
            })}
          </Dropdown.Menu>
        </Dropdown>
        {typeof this.props.searchComponent !== 'undefined' && (
          <div className="search-container">{this.props.searchComponent}</div>
        )}
      </div>
    )
  }

  renderSubMenuForItem(item) {
    if (!item.path) {
      return null
    }

    return (
      <Route
        key={item.label}
        path={item.path}
        render={() => {
          if (!item.subItems) {
            return <div className="submenu-empty"></div>
          }
          return (
            <ul className="submenu-items">
              {item.subItems.map((subitem) => {
                return <li key={subitem.label}>{this.renderMenuLink(subitem)}</li>
              })}
            </ul>
          )
        }}
      />
    )
  }

  renderSubMenuItems() {
    return this.props.menuItems.map((item) => {
      return this.renderSubMenuForItem(item)
    })
  }

  renderScoirLogo() {
    const logo = (
      <img
        className="scoir-logo"
        src={scoirLogo}
      />
    )
    if (this.props.scoirLogoDestination) {
      return <Link to={this.props.scoirLogoDestination}>{logo}</Link>
    } else if (this.props.scoirLogoExternalDestination) {
      return <a href={this.props.scoirLogoExternalDestination}>{logo}</a>
    }
    return logo
  }

  render() {
    return (
      <div
        className="tiered-navigation-comp-container"
        style={{ height: `${this.state.headerHeight}px` }}
      >
        <Typography variant="srOnly">
          <a
            id="main-nav-skip-to-content"
            href="#app-main-content"
            aria-label="skip to main content"
          >
            Skip to main content
          </a>
        </Typography>
        <div
          className="tiered-navigation-comp"
          ref={(ref) => (this.fixedNavRef = ref)}
        >
          <div className="header-summary">
            {this.renderScoirLogo()}
            <span className="organization-name">{this.props.organizationName}</span>
            <div className="notice-bar pull-right">
              <Dropdown
                className="settings-dropdown"
                componentClass="span"
                id="menu-navigation-settings-dropdown"
                pullRight
              >
                <OpaqueDropdownToggle bsRole="toggle">
                  <div className="user-toolbar">
                    <img
                      className="avatar-icon"
                      src={this.getAvatarUrl(this.props.userAvatarUrl)}
                    />
                    <span className="user-name">
                      Welcome {this.props.userName}
                      <Icon
                        def={downArrowIcon}
                        size="xs"
                      />
                    </span>
                  </div>
                </OpaqueDropdownToggle>
                <Dropdown.Menu>
                  {this.props.settingsItems.map((item) => {
                    return (
                      <OpaqueDropdownMenuItem key={item.label}>
                        {item.path && <NavLink to={item.path}>{item.label}</NavLink>}
                        {item.externalPath && <a href={item.externalPath}>{item.label}</a>}
                        {item.onClick && <a onClick={item.onClick}>{item.label}</a>}
                      </OpaqueDropdownMenuItem>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
              {this.props.messagingComponent && (
                <div className="messaging-container">{this.props.messagingComponent}</div>
              )}
              {typeof this.props.inboxComponent !== 'undefined' && this.props.inboxComponent}
            </div>
          </div>
          {this.props.menuItems && (
            <Fragment>
              <div className="menu-navigation">{this.renderMenuItems()}</div>

              <div className="submenu-navigation">{this.renderSubMenuItems()}</div>
            </Fragment>
          )}
        </div>
      </div>
    )
  }
}

TieredNavigation.propTypes = {
  scoirLogoDestination: PropTypes.string,
  scoirLogoExternalDestination: PropTypes.string,
  organizationName: PropTypes.string,
  userAvatarUrl: PropTypes.string,
  userName: PropTypes.string,
  inboxComponent: PropTypes.node,
  messagingComponent: PropTypes.node,
  searchComponent: PropTypes.node,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      onClick: PropTypes.func,
      label: PropTypes.string.isRequired,
      subItems: PropTypes.arrayOf(
        PropTypes.shape({
          path: PropTypes.string,
          label: PropTypes.string.isRequired,
        }),
      ),
    }),
  ),
  settingsItems: PropTypes.arrayOf(PropTypes.object),
}

TieredNavigation.defaultProps = {
  settingsItems: [],
}

TieredNavigation.NotificationsIndicator = TieredNavagationNotificationsIndicator
TieredNavigation.Messaging = TieredNavigationMessaging
TieredNavigation.Inbox = TieredNavigationInbox
TieredNavigation.SearchBox = SearchBox
export default TieredNavigation
